
export const domain = "https://asfconsult-002-site1.ftempurl.com";
export const Url = `${domain}/api/`;